import { ReactNode } from "react";
import MuiSkeleton from "@mui/material/Skeleton";
import { SkeletonProps as MuiSkeletonProps } from "@mui/material";

interface SkeletonProps extends Omit<MuiSkeletonProps, "children"> {
  /**
   * Width of the skeleton. Can be any CSS width value.
   */
  width?: string | number;
  /**
   * Height of the skeleton. Can be any CSS height value.
   */
  height?: string | number;
  /**
   * Variant of the skeleton. 'text', 'circular', or 'rectangular'.
   * @default 'text'
   */
  variant?: "text" | "circular" | "rectangular";
  /**
   * Animation style of the skeleton.
   * @default 'pulse'
   */
  animation?: "pulse" | "wave" | false;
  /**
   * Controls if the skeleton is shown or the children content.
   * @default true
   */
  isLoading?: boolean;
  /**
   * Content to show when not loading.
   */
  children?: ReactNode;
  /**
   * Skeleton margin
   * Adds margin only when skeleton is visible - Can be any CSS margin value.
   */
  margin?: string | number;
}

export const Skeleton = ({
  width,
  height,
  animation,
  children,
  margin,
  variant = "rectangular",
  isLoading = true,
  ...rest
}: SkeletonProps) => {
  if (!isLoading && children) {
    return <>{children}</>;
  }

  return (
    <MuiSkeleton
      variant={variant}
      animation={animation}
      width={width}
      height={height}
      sx={{
        borderRadius: variant === "rectangular" ? 1 : "",
        margin,
      }}
      {...rest}
    />
  );
};
